<template>
  <CBadge :color="getBadge(booleanValue)">
    {{ booleanValue ? 'Yes' : 'No' }}
  </CBadge>
</template>
<script>
export default {
  name: 'BooleanBadge',

  props: {
    booleanValue: {
      type: Boolean,
      default: false
    },
  },

  methods: {
    getBadge(booleanValue) {
      return booleanValue ? 'success' : 'danger'
    }
  },
}
</script>
<style lang="">
  
</style>